import { createFileRoute } from '@tanstack/react-router';

import { DmaModuleHomePage } from '@/features/esg/dma/components/DmaModuleHomePage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/')({
  component: DmaModuleHomeRoute,
});

function DmaModuleHomeRoute() {
  return <DmaModuleHomePage />;
}
